<template>
  <screen-locker>
    <template v-slot:content>
      <div
        class="page page-contributions d-flex flex-column align-items-start flex-fill"
      >
        <AppHeader :step-active="3"></AppHeader>
        <div class="row header-page">
          <div class="col">
            <h3>
              Scopri gli impatti positivi del<br />dell'investimento di
              {{
                $store.state.capitalValue
                  | currency({
                    symbol: "€",
                    thousandsSeparator: ".",
                    fractionCount: 0,
                    fractionSeparator: ",",
                    symbolPosition: "",
                    symbolSpacing: true
                  })
              }}
            </h3>
            <div class="row h-100">
              <div class="col h-100">
                <div class="banner banner-description h-100">
                  <div class="row">
                    <div class="col-12 position-absolute">
                      <div
                        class="svg-banner-area w-100 h-100 d-flex align-items-center"
                        v-bind:style="{
                          'padding-left': window.width <= 1440 ? 0 : '20%'
                        }"
                        v-bind:class="getBannerClasses(selectedTab)"
                      >
                        <svg-viewer
                          :src="
                            window.width <= 1440
                              ? require('../assets/images/banner/04-main.svg')
                              : require('../assets/images/banner/04-wide.svg')
                          "
                          width="100%"
                          :height="window.width <= 1440 ? '200px' : '350px'"
                        ></svg-viewer>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      I portafoglio di investimento sostenibile (fondi interni)
                      sono affiancati dalla solidità della gestione separata
                      assicurativa GESAV, su cui viene investito il 40% del tuo
                      premio. Per ogni fondo interno che hai scelto puoi
                      valutare gli effetti positivi e concreti del tuo investimento
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="d-flex flex-row flex-wrap mt-4">
                        <img
                          v-for="sdg in areaList
                            .map(a => a.sdg)
                            .reduce((acc, it) => [...acc, ...it], [])"
                          :key="sdg.id"
                          :src="sdg.icon"
                          :alt="sdg.title"
                          class="sdg-icon mr-2 mb-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-data mt-3 pt-auto w-100">
          <div class="row">
            <div class="col mt-3">
              <b-tabs
                pills
                class="list-tabs tab-customize"
                v-if="areaList.length > 0"
                v-model="selectedTab"
              >
                <b-tab
                  :title="item.title"
                  v-for="(item, index) in areaList"
                  :key="index"
                  @click="changeTabs()"
                >
                  <b-card-text>
                    <div class="mb-2">
                      {{ item.title }} ({{
                        item.value
                          | currency({
                            symbol: "€",
                            thousandsSeparator: ".",
                            fractionCount: 0,
                            fractionSeparator: ",",
                            symbolPosition: "",
                            symbolSpacing: true
                          })
                      }}) i contributi sono:
                    </div>
                    <div class="d-flex">
                      <contrib-panel
                        :title="contrib.title"
                        :text="contrib.text"
                        :icon="contrib.icon"
                        v-for="(contrib, index) in item.contribs"
                        :key="index"
                      ></contrib-panel>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab
                  @update:active="openCustomPerc()"
                  @click="changeTabs()"
                  title-link-class="customizeAction"
                  v-if="areaList.length > 0 && false"
                >
                  <template v-slot:title>
                    <strong class="ml-2">Personalizza</strong>
                  </template>
                  <b-card-text>
                    <div style="height: 184px;">&nbsp;</div>
                  </b-card-text>
                </b-tab>
              </b-tabs>
              <div class="contribs-source mt-auto">
                Elaborazioni Mainstreet Partners 2019
              </div>
            </div>
          </div>
        </div>
        <div class="footer-page w-100">
          <div class="d-flex">
            <b-button variant="link" @click="back()">
              <img alt="Indietro" src="../assets/images/back.svg" />
              Indietro
            </b-button>
            <b-button
              variant="primary ml-auto"
              :disabled="disabledNextStep()"
              @click="processData()"
              >Avanti</b-button
            >
          </div>
        </div>
        <b-modal
          v-model="modal"
          adaptive="true"
          title="Overflowing Content"
          dialog-class="modal-full"
          hide-footer
          @hide="updateData()"
        >
          <template v-slot:modal-header>
            &nbsp;
            <b-button
              variant="link modal-close"
              size="sm"
              class="float-right"
              @click="modal = false"
            >
              <img src="../assets/images/close.svg" alt="Chiudi" />
            </b-button>
          </template>
          <b-container style="height: 80vh">
            <custom-contribs-value
              v-if="modal"
              @modalAction="modalAction"
            ></custom-contribs-value>
          </b-container>
        </b-modal>
      </div>
    </template>
    <auth-guard />
  </screen-locker>
</template>

<script>
import router from "../router";
import ContribPanel from "../components/ContribPanel";
import CustomContribsValue from "./modals/CustomContribsValue";
import { getAreaListData } from "../data/area-list.data";
export default {
  name: "Contributions",
  components: { CustomContribsValue, ContribPanel },
  data: () => {
    return {
      val: false,
      modal: false,
      selectedTab: 0,
      lastTab: 0,
      areaList: [],
      tabMap: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    this.initAreaListValues();
    this.areaList = this.areaList.filter(
      a => this.$store.state.areaValue.filter(sa => sa.id === a.id).length > 0
    );
    this.updateAreaData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    initAreaListValues() {
      this.areaList = JSON.parse(
        JSON.stringify(getAreaListData(this.$store.state.areaValue))
      );
      // console.log("this.areaList", this.areaList);
    },
    updateContribsvalues() {
      // tutela clima
      this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 2)[0].text = this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 2)[0]
        .text.replace("{1}", 0.14 * Number(this.$store.state.capitalValue));
      this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 2)[0].text = this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 2)[0]
        .text.replace("{2}", 0.001 * Number(this.$store.state.capitalValue));

      this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 1)[0].text = this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 1)[0]
        .text.replace("{1}", 104.16 * Number(this.$store.state.capitalValue));
      this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 1)[0].text = this.areaList
        .filter(a => a.id === 1)[0]
        .contribs.filter(c => c.id === 1)[0]
        .text.replace("{2}", 1.5 * Number(this.$store.state.capitalValue));

      // consumo responsabile
      this.areaList
        .filter(a => a.id === 3)[0]
        .contribs.filter(c => c.id === 1)[0].text = this.areaList
        .filter(a => a.id === 3)[0]
        .contribs.filter(c => c.id === 1)[0]
        .text.replace("{1}", 104.16 * Number(this.$store.state.capitalValue));
      this.areaList
        .filter(a => a.id === 3)[0]
        .contribs.filter(c => c.id === 1)[0].text = this.areaList
        .filter(a => a.id === 3)[0]
        .contribs.filter(c => c.id === 1)[0]
        .text.replace("{2}", 1.5 * Number(this.$store.state.capitalValue));

      this.areaList.filter(
        a => a.id === 4
      )[0].contribs[0].text = this.areaList
        .filter(a => a.id === 4)[0]
        .contribs[1].text.replace(
          "{1}",
          0.038 * Number(this.$store.state.capitalValue)
        );
    },
    updateAreaData() {
      this.areaList.filter(a => {
        if (this.$store.state.areaValue.filter(v => v.id === a.id).length > 0) {
          a.selected = true;
          a.value = this.$store.state.areaValue.filter(
            v => v.id === a.id
          )[0].value * 1.2; // 60% of CapitalValue
        } else {
          a.selected = false;
          a.value = 0;
        }
        return true;
      });
      this.areaList
        .filter(a => a.selected)
        .forEach((area, index) => {
          this.tabMap[index] = area.svgClass;
        });
    },
    disabledNextStep() {
      return false;
    },
    processData() {
      if (!this.disabledNextStep()) {
        router.push("/extra-protections");
      }
    },
    showModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    updateData() {
      this.updateAreaData();
    },
    back() {
      router.push("areas");
    },
    modalAction(action) {
      if (action === "close") {
        this.closeModal();
      }
    },
    changeTabs() {
      this.lastTab = this.selectedTab;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getBannerClasses(tabSelected) {
      const result = [];
      let className = "";

      className = `svg-area-${this.tabMap[tabSelected]}`;

      result.push(className);
      return result;
    }
  }
};
</script>
